import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown/with-html';
import { object } from 'prop-types';

const QuestionDiv = styled.div`
  text-align: left;
  margin: 32px;
  @media(min-width: 1000px) {
    margin: 32px 6%;
    flex-basis: 38%;
  }
`;

const PurpleBar = styled.hr`
  width: 53px;
  height: 4px;
  border-radius: 2px;
  background-color: #9027b0;
  margin: 0 0 21px 0;
  border: none;
`;

const Title = styled.span`
  font-size: 20px;
  line-height: 1.4;
  padding-top: 21px;
  color: #4a4a4a;
`;

const Reply = styled(ReactMarkdown)`
  margin-top: 10px;

  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #999999;
  }

  strong {
    font-weight: bold;
  }

  a {
    color: #9027b0;
    text-decoration: none;
  }
`;

function Question({ question }) {
  return (
    <QuestionDiv>
      <PurpleBar />
      <Title>{question.title}</Title>
      {question.replies.map(reply => <Reply key={reply} source={reply} escapeHtml={false} />)}
    </QuestionDiv>
  );
}

Question.propTypes = {
  question: object.isRequired,
};


export default Question;
